import React from "react";

function Servicios() {
  return (
    <div className="container m-auto my-12">
      <div className="flex flex-col justify-center items-center my-12">
        <h1 className="text-justify font-times font-bold text-4xl">
          Servicios
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mx-8 py-8 h-auto">

          <div className="flex flex-col justify-center items-center border-1 shadow-xl shadow-slate-600 border-gray-600 p-5 rounded-md">
            <h1 className="text-justify font-times font-bold text-2xl">
              1. Diagnóstico Estratégico de Transformación
            </h1>
            <p className="text-justify font-times text-xl">
              Una sesión profunda diseñada para identificar con claridad los bloqueos, oportunidades y áreas clave de crecimiento personal o empresarial.<br />
              <span className="font-bold">Ideal para:</span><br />
              Personas, emprendedores, líderes y empresarios que desean claridad sobre su situación actual y los pasos necesarios para avanzar.<br />
              <span className="font-bold">Incluye</span>
            </p>
            <ul>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Análisis de mentalidad y enfoque actual</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Identificación de bloqueos personales o estratégicos</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Claridad sobre prioridades de crecimiento</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Recomendaciones prácticas para avanzar</li>
            </ul>
            <span className="text-justify text-xl font-times font-bold my-5">Duración</span>
            <span className="text-justify text-xl font-times">1 sesión de 90 minutos</span>
          </div>

          <div className="flex flex-col justify-center items-center border-1 shadow-xl shadow-slate-600 border-gray-600 p-5 rounded-md">
            <h1 className="text-justify font-times font-bold text-2xl">
              2. Programa Despertar Interior
            </h1>
            <p className="text-justify font-times text-xl">
              Un proceso estructurado de transformación diseñado para ayudar a las personas a fortalecer su mentalidad, desarrollar claridad en sus objetivos y construir una vida con mayor propósito y resultados.<br />
              <span className="font-bold">Incluye</span><br />
              4 sesiones de mentoría personalizada + seguimiento por whatsApp<br />
            </p>
            <ul>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Mentalidad de crecimiento</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Identificación y superación de creencias limitantes</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Claridad de propósito y dirección</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Desarrollo de disciplina y enfoque</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Estrategia personal para crecimiento sostenido</li>
            </ul>
            <span className="text-justify text-xl font-times font-bold my-5">Duración</span>
            <span className="text-justify text-xl font-times">6 semanas</span>
          </div>

          <div className="flex flex-col justify-center items-center border-1 shadow-xl shadow-slate-600 border-gray-600 p-5 rounded-md">
            <h1 className="text-justify font-times font-bold text-2xl">
              3. Mentoría de Alto Rendimiento
            </h1>
            <p className="text-justify font-times text-xl">
              Un proceso de acompañamiento profundo dirigido a líderes, emprendedores y empresarios que desean expandir su visión, fortalecer su liderazgo y desarrollar resultados extraordinarios.<br />
              <span className="font-bold">Incluye</span><br />
              6 sesiones de mentoría estratégica
            </p>
            <ul>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Mentalidad de alto rendimiento</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Claridad estratégica</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Liderazgo personal y empresarial</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Toma de decisiones efectivas</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Desarrollo de hábitos de éxito</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Expansión de visión y resultados</li>
            </ul>
            <span className="text-justify text-xl font-times font-bold my-5">Duración</span>
            <span className="text-justify text-xl font-times">3 meses</span>
          </div>

          <div className="flex flex-col justify-center items-center border-1 shadow-xl shadow-slate-600 border-gray-600 p-5 rounded-md">
            <h1 className="text-justify font-times font-bold text-2xl">
              4. Programas Empresariales
            </h1>
            <p className="text-justify font-times text-xl">
              También acompañamos a empresas y organizaciones que desean desarrollar equipos más conscientes, enfocados y productivos.<br/>
              <span className="font-bold">Conferencias y entrenamientos corporativos</span><br/>
              Programas diseñados para fortalecer la mentalidad, el liderazgo y la cultura de crecimiento dentro de las organizaciones.<br/>
              <span className="font-bold">Temas principales</span>

            </p>
            <ul>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">✓</span>Mentalidad de alto rendimiento</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">✓</span>Liderazgo consciente</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">✓</span>Cultura organizacional de crecimiento</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">✓</span>Gestión emocional y productividad</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">✓</span>Desarrollo del potencial humano</li>
            </ul>
            <span className="text-justify text-xl font-bold font-times">Modalidades</span>
            <ul>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Conferencias</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Talleres</li>
              <li className="text-justify text-xl font-times"><span className="text-green-500 text-xl mx-3">•</span>Programas de formación empresarial</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  )
}

export default Servicios;